var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.props),function(item){return _c('div',{key:item.id,staticClass:"d-flex justify-content-between mb-4"},[_c('app-media-object',{attrs:{"img-url":item.avatar,"media-title":item.title,"media-subtitle":item.subtitle}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }